<!--字典数据-->
<template>
    <div>
        <!--顶部搜索-->
        <el-row :gutter="20">
            <el-form :model="queryInfo" ref="queryForm" :size="size" label-width="68px">
                <el-col :span="4">
                    <el-form-item label="数据标签" prop="label">
                        <el-input
                                v-model="queryInfo.label"
                                placeholder="输入数据标签"
                                clearable
                                @keyup.enter.native="handleQuery"/>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="字典类型" prop="type">
                        <el-select v-model="queryInfo.type" placeholder="选择字典类型" clearable>
                            <el-option
                                    v-for="item in typeList"
                                    :key="item.type"
                                    :label="item.name"
                                    :value="item.type">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="数据状态" prop="status">
                        <el-select
                                v-model="queryInfo.status"
                                placeholder="数据状态"
                                clearable>
                            <el-option
                                    v-for="dict in status"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"/>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item label="创建时间">
                        <el-date-picker
                                v-model="dateRange"
                                value-format="yyyy-MM-dd"
                                type="daterange"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-button :size="size" v-permission="['SYS-DICT-DATA-PAGE']" type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
                    <!--<el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
                </el-col>
                <el-col :span="3" style="text-align: right">
                    <el-button :size="size" v-permission="['SYS-DICT-DATA-ADD']" type="primary" icon="el-icon-plus" @click="addDialog">添加</el-button>
                    <el-button :size="size" type="danger" icon="el-icon-delete" :disabled="multiple" @click="deleteDialog('bat')">删除</el-button>
                </el-col>
            </el-form>
        </el-row>
        <el-table v-loading="loading" ref="tableRef" border stripe checkBox :height="treeTableHeight" :data="tablelist" @selection-change="handleSelectionChange">
            <template v-for="(v,k) in columns">
                <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-if="v.label==='操作'">
                    <template slot-scope="scope">
                        <el-button v-permission="['SYS-DICT-DATA-UPDATE']" type="primary" icon="el-icon-edit" size="mini" round @click="editDialog(scope.row)">编辑</el-button>
                        <el-button v-permission="['SYS-DICT-DATA-DELETE']" type="danger" icon="el-icon-delete" size="mini" round @click="deleteDialog('single',scope.row)">删除</el-button>
                    </template>
                </el-table-column>
                <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='status'">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="!scope.row.status">正常</el-tag>
                        <el-tag type="info" v-else-if="scope.row.status">停用</el-tag>
                        <el-tag v-else></el-tag>
                    </template>
                </el-table-column>
                <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='isDefault'">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.isDefault">是</el-tag>
                        <el-tag type="info" v-else>否</el-tag>
                    </template>
                </el-table-column>
                <el-table-column :type="v.type" :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else></el-table-column>
            </template>
        </el-table>
        <Pagination v-show="total>0" :total="total" :page="queryInfo.pagenum" :limit="queryInfo.pagesize" @updatePage="handleCurrentChange" @updateLimit="handleSizeChange" ></Pagination>
        <!-- 添加或修改参数配置对话框 -->
        <el-dialog :title="title" :visible.sync="editDialogVisible"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :destroy-on-close="true" width="500px" append-to-body @close="handleClose">
            <el-form ref="editFormRef" :model="editItem" :rules="formRules" label-width="80px">
                <el-form-item label="数据标签" prop="label">
                    <el-input v-model="editItem.label" placeholder="请输入数据标签" clearable/>
                </el-form-item>
                <el-form-item label="数据键值" prop="value">
                    <el-input v-model="editItem.value" placeholder="请输入数据键值" clearable/>
                </el-form-item>
                <el-form-item label="字典类型" prop="type">
                    <el-select v-model="editItem.type" placeholder="请选择字典类型" style="width: 100%;">
                        <el-option
                                v-for="item in typeList"
                                :key="item.type"
                                :label="item.name"
                                :value="item.type">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数据状态" prop="status">
                    <el-radio-group v-model="editItem.status">
                        <el-radio
                                v-for="dict in status"
                                :key="dict.value"
                                :label="dict.value"
                        >{{dict.label}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否默认" prop="isDefault">
                    <el-switch
                            v-model="editItem.isDefault"
                            active-text="是" :active-value="true"
                            inactive-text="否" :inactive-value="false">
                    </el-switch>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="editItem.remark" type="textarea" placeholder="请输入内容" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {dictDataRemove, dictPage, dictDataAdd, dictDataEdit, dictTypePage} from '@/api/dict'
    import Pagination from '@/components/pagination/index'
    export default {
        name: 'SYS-DICT-DATA',
        components:{
            Pagination
        },
        data() {
            return {
                queryInfo:{
                    pagesize: 10,
                    pagenum: 1,
                    // status: false
                },
                status: [
                    {value: false,label: '正常'},
                    {value: true,label: '停用'}
                ],
                total: 0,
                treeTableHeight: 650,
                tablelist: [],
                columns:[
                    {
                        type:'selection',
                        width: '55px',
                        fixed: 'left'
                    },{
                        label: '数据编码',
                        prop: 'code',
                        fixed: 'left',
                        width: '80px'
                    },{
                        label: '数据标签',
                        prop: 'label',
                        width: '360px'
                    },{
                        label: '数据键值',
                        prop: 'value',
                        width: '260px'
                    },{
                        label: '字典类型',
                        prop: 'type',
                        width: '260px'
                    },/*{
                        label: '样式属性',
                        prop: 'cssClass'
                    },{
                        label: '回显样式',
                        prop: 'listClass'
                    },*/{
                        label: '是否默认',
                        prop: 'isDefault',
                        width: '70px'
                    },{
                        label: '状态',
                        prop: 'status',
                        width: '70px'
                    },/*{
                        label: '创建者',
                        prop: 'createBy',
                        width: 100
                    },*/{
                        label: '创建时间',
                        prop: 'createTime',
                        width: '150px'
                    },/*{
                        label: '更新者',
                        prop: 'updateBy',
                        width: 100
                    },*/{
                        label: '更新时间',
                        prop: 'updateTime',
                        width: '150px'
                    },{
                        label: '备注',
                        prop: 'remark',
                        width: '360px'
                    },{
                        label: '操作',
                        type: 'template',
                        template: 'action',
                        width: '180px',
                        fixed: 'right'
                    }
                ],
                ids: [],
                // 非单个禁用
                // single: true,
                // 非多个禁用
                multiple: true,
                editDialogVisible: false,
                title: '',
                editItem: {},
                // 表单校验
                formRules: {
                    label: [
                        { required: true, message: "数据标签不能为空", trigger: "blur" }
                    ],
                    type: [
                        { required: true, message: "字典类型不能为空", trigger: "blur" }
                    ],
                    value: [
                        { required: true, message: "数据键值不能为空", trigger: "blur" }
                    ]
                },
                dateRange: [],
                typeList: [],
                size: this.COMMON.size,
                loading: true
            }
        },
        methods: {
            init(){
                if(this.queryInfo.label!=undefined) {
                    this.queryInfo.label = this.queryInfo.label.trim()
                }
                if(this.dateRange!=null && this.dateRange.length>0){
                    this.queryInfo.startDate = this.dateRange[0]
                    this.queryInfo.endDate = this.dateRange[1]
                }else{
                    this.queryInfo.startDate = null
                    this.queryInfo.endDate = null
                }
                let param = {}
                param.current = this.queryInfo.pagenum
                param.size = this.queryInfo.pagesize
                this.loading = true
                dictPage(param,this.queryInfo).then(response => {
                    if(response.code!=200)  return this.$message.error(response.msg)
                    this.tablelist = response.data.records
                    this.total = response.data.total
                    // console.log('字典数据分页',this.tablelist)
                    this.loading = false
                })
            },
            getHeight() {
                // this.objstyle.height = window.innerHeight - 170 -55 -40 + 'px'
                this.treeTableHeight = window.innerHeight - 60 -40 -55 -62 -32 + 'px'
            },
            /** 搜索按钮操作 */
            handleQuery() {
                this.queryInfo.pagenum=1
                this.init()
            },
            handleCurrentChange(newPage) {
                this.queryInfo.pagenum = newPage
                this.init()
            },
            handleSizeChange(newSize) {
                this.queryInfo.pagesize = newSize
                this.init()
            },
            // 多选框选中数据
            handleSelectionChange(selection) {
                this.ids = selection.map(item => item.code)
                // console.log(this.ids,selection)
                // this.single = selection.length!=1
                this.multiple = !selection.length
            },
            handleClose() {
                this.$refs.editFormRef.resetFields()
                this.editDialogVisible = false
            },
            addDialog(){
                this.title='添加字典数据'
                this.editItem = {status: false,isDefault: false}
                this.editDialogVisible = true
            },
            editDialog(item){
                this.editItem = JSON.parse(JSON.stringify(item))
                this.title='编辑字典数据'
                this.editDialogVisible = true
            },
            async deleteDialog(type ,item){
                // console.log(type)
                const confirmResult = await this.$confirm('此操作将删除该字典数据记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).catch(err => err)
                // 如果用户确认删除，则返回值未字符串 confirm
                // 如果用户取消了删除，则返回值未字符串 cancel
                if (confirmResult !== 'confirm') {
                    return this.$message.info('取消删除')
                }
                let idpara=[]
                if(type==='bat'){
                    idpara = this.ids
                }else if(type==='single'){
                    idpara.push(item.id)
                }
                dictDataRemove(idpara).then(response => {
                    if(response.code!=200){
                        return this.$message.error(response.msg)
                    }
                    this.$message.success(response.msg)
                    this.init()
                })
            },
            submitForm(){
                this.$refs.editFormRef.validate(async valid => {
                    if (!valid) return
                    if(this.title==='添加字典数据'){
                        dictDataAdd(this.editItem).then(response => {
                            if(response.code!=200){
                                return this.$message.error(response.msg)
                            }
                            this.$message.success(response.msg)
                            this.init()
                            this.editDialogVisible = false
                        })
                    }else{
                        dictDataEdit(this.editItem).then(response => {
                            if(response.code!=200){
                                return this.$message.error(response.msg)
                            }
                            this.$message.success(response.msg)
                            this.init()
                            this.editDialogVisible = false
                        })
                    }
                })
            },
            getDictType(){
                let param = {}
                param.current = 1
                param.size = 100
                dictTypePage(param, {}).then(response => {
                    if(response.code!=200)  return this.$message.error(response.msg)
                    this.typeList = response.data.records
                })
            }
        },
        created(){
            this.getHeight()
            window.addEventListener('resize', this.getHeight)
            this.init()
            this.getDictType()
        },
        activated(){
            this.$refs.tableRef.doLayout()
        }
    }
</script>

<style scoped>

</style>
